/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import {
  createSavedAddress,
  deleteSavedAddress,
} from "../../../graphql/mutations";
import jsonExport from "jsonexport/dist";

import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  Button,
  Datagrid,
  downloadCSV,
  FilterButton,
  FormDataConsumer,
  ListContextProvider,
  ListToolbar,
  TextField,
  TopToolbar,
  useList,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import { AddressDialog } from "../../../components/common/AddressDialog";
import {
  CreateIcon,
  EditIcon,
  ExportIcon,
  ImportIcon,
  RemoveIcon,
} from "../../../components/common/iconography";
import { Pagination } from "../../../components/Pagination";
import { SearchField } from "../../../components/common/SearchField";
import { isSubscriptionDisabled, logError } from "../../../utils/appUtils";
import { fetchSavedAddresses, updateSavedAddressRecord } from "./AccountUtils";
import { AddressImportDialog } from "./AddressImportDialog";
import { describeImportSummary } from "./addressImportUtils";

const useStyles = makeStyles((theme) => ({
  searchField: {
    minWidth: "16rem",
    marginTop: theme.spacing(3),
  },
  actionButton: {
    marginLeft: theme.spacing(1),
  },
}));

const exportList = (addresses, account) => {
  debugger;
  const addressesForExport = [];

  Object.values(addresses).forEach((address) => {
    const addressExport = {
      id: address.id,
      name: address.name || "",
      street: address.street,
      city: address.city,
      state: address.state,
      zipCode: address.zipCode,
      country: address.country,
    };

    debugger;
    addressesForExport.push(addressExport);
  });

  jsonExport(addressesForExport, { rename: [] }, (err, csv) => {
    downloadCSV(csv, `${account.businessName}_addressBook`); // download as 'addressBook.csv` file
  });
};

const AddressSearchField = (props) => {
  const classes = useStyles();
  const { allAddresses, setAddresses, label, alwaysOn } = props;

  const handleSearch = (value) => {
    debugger;
    const searchTerm = value?.toLowerCase() || "";
    const filteredAddresses = allAddresses.filter(
      (itm) =>
        itm.name?.toLowerCase().includes(searchTerm) ||
        itm.street?.toLowerCase().includes(searchTerm) ||
        itm.city?.toLowerCase().includes(searchTerm) ||
        itm.state?.toLowerCase().includes(searchTerm) ||
        itm.zipCode?.toLowerCase().includes(searchTerm),
    );
    setAddresses(filteredAddresses);
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      className={classes.searchField}
      handleSearch={handleSearch}
      searchOnChange={true}
    />
  );
};

const getListFilters = (allAddresses, setAddresses) => [
  <AddressSearchField
    label="Address Search"
    allAddresses={allAddresses}
    setAddresses={setAddresses}
    alwaysOn
  />,
];

/**
 * The next client-side id for an address staged during account create.
 *
 * List position is not usable: Remove filters the list by id and leaves the
 * gap, so the next length-based id collides with an address that is still
 * there. useList keys its record map by id, so a collision merges two rows
 * into one and Remove on that row drops both. The ids are stripped again
 * before the addresses are written (see createSavedAddresses), so only
 * uniqueness within the staged list matters.
 */
const nextStagedAddressId = (allAddresses) =>
  (allAddresses || []).reduce(
    (next, address) =>
      Number.isFinite(Number(address?.id))
        ? Math.max(next, Number(address.id) + 1)
        : next,
    0,
  );

const ListActions = (props) => {
  const classes = useStyles();
  const {
    form,
    formData,
    allAddresses,
    setAllAddresses,
    hasCreate,
    notify,
    loading,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const [importing, setImporting] = useState(false);

  const handleCreate = () => {
    debugger;
    form.change("savedAddress", {
      id: formData.id ? undefined : nextStagedAddressId(allAddresses), // handle account create
      accountId: formData.id, // handle account create
      groups: window.appUser.groups,
      reloadYardId: window.appUser.reloadYardId,
    });
    setIsOpen(true);
  };

  const handleSave = async () => {
    debugger;
    try {
      let newAddress = formData.savedAddress;
      if (newAddress?.accountId) {
        const result = await API.graphql(
          graphqlOperation(createSavedAddress, { input: newAddress }),
        );
        newAddress = result.data.createSavedAddress;
        notify("Address created successfully.");
      }
      // Functional update: on an existing account fetchSavedAddresses may
      // still be filling the book while the save is in flight, and the list
      // this handler was rendered with would overwrite what it loaded.
      setAllAddresses((current) => [...current, newAddress]);

      form.change(`savedAddress`, undefined);
      setIsOpen(false);
    } catch (error) {
      logError("accounts:AddressBook:handleSave", error, notify);
    }
  };

  /**
   * Save the rows the import dialog approved.
   *
   * On an existing account each row is written to AppSync; on an account that
   * is still being created there is nothing to attach them to yet, so they join
   * the in-form list the create button writes once the account has an id — the
   * same two paths the single-address Create button already takes.
   *
   * `skipped` is what the dialog's review panel left out. It is carried into
   * every notification so the count the manager reviewed is still on screen
   * after the dialog closes.
   */
  const handleImport = async (importedAddresses, skipped = 0) => {
    if (!importedAddresses?.length) {
      // Nothing to write, but a file whose every row was skipped still has to
      // say so — closing the dialog in silence reads as a successful import.
      if (skipped)
        notify(describeImportSummary({ created: 0, skipped }), "warning");
      return;
    }

    try {
      setImporting(true);

      if (!formData.id) {
        // Account create: the rows join the in-form list under ids that are
        // stripped again before they are written (see createSavedAddresses).
        // Ids are assigned inside the updater so they are unique against the
        // list as it stands when the update applies, not as it was rendered.
        setAllAddresses((current) => {
          const firstId = nextStagedAddressId(current);
          return [
            ...current,
            ...importedAddresses.map((address, index) => ({
              ...address,
              groups: window.appUser.groups,
              reloadYardId: window.appUser.reloadYardId,
              id: firstId + index,
            })),
          ];
        });
        notify(
          describeImportSummary({ created: importedAddresses.length, skipped }),
          skipped ? "warning" : "info",
        );
        return;
      }

      const results = await Promise.allSettled(
        importedAddresses.map((address) =>
          API.graphql(
            graphqlOperation(createSavedAddress, {
              input: {
                ...address,
                accountId: formData.id,
                groups: window.appUser.groups,
                reloadYardId: window.appUser.reloadYardId,
              },
            }),
          ),
        ),
      );

      // The rows that were written are added whatever happened to the rest, so
      // the grid matches the account's book rather than the file. A failure is
      // counted and named once — re-uploading the same file skips what landed,
      // since those rows are now duplicates.
      const created = results
        .filter((result) => result.status === "fulfilled")
        .map((result) => result.value.data.createSavedAddress);
      const failed = results.filter((result) => result.status === "rejected");

      // Functional update: fetchSavedAddresses may still be filling the book
      // while the rows are written, and the list this handler was rendered
      // with would replace what it loaded with only the imported rows.
      if (created.length)
        setAllAddresses((current) => [...current, ...created]);

      failed.forEach((result) =>
        logError("accounts:AddressBook:handleImport", result.reason, false),
      );

      notify(
        describeImportSummary({
          created: created.length,
          skipped,
          failed: failed.length,
        }),
        failed.length || skipped ? "warning" : "info",
      );
    } catch (error) {
      logError("accounts:AddressBook:handleImport", error, notify);
    } finally {
      setImporting(false);
    }
  };

  const handleClose = () => {
    form.change("savedAddress", undefined);
    setIsOpen(false);
  };

  return (
    <TopToolbar>
      <FilterButton />
      {hasCreate && (
        <Button
          label="Create"
          color="primary"
          className={classes.actionButton}
          onClick={handleCreate}
          disabled={isSubscriptionDisabled()}
        >
          <CreateIcon />
        </Button>
      )}
      <Button
        label="Import"
        size="small"
        color="primary"
        className={classes.actionButton}
        onClick={() => setImportOpen(true)}
        // The dialog plans duplicates against the loaded book; until the
        // account's addresses have arrived it would plan against nothing and
        // write every row again.
        disabled={loading || importing || isSubscriptionDisabled()}
      >
        {importing ? (
          <CircularProgress color="inherit" size={17} />
        ) : (
          <ImportIcon />
        )}
      </Button>
      <Button
        label="Export"
        size="small"
        color="primary"
        disabled={!allAddresses?.length}
        onClick={() => exportList(allAddresses, formData)}
      >
        <ExportIcon />
      </Button>
      {isOpen && (
        <AddressDialog
          open={isOpen}
          title="Add Address"
          formData={formData}
          onSave={handleSave}
          onClose={handleClose}
        />
      )}
      {importOpen && (
        <AddressImportDialog
          isOpen={importOpen}
          setIsOpen={setImportOpen}
          existingAddresses={allAddresses}
          handleImport={handleImport}
        />
      )}
    </TopToolbar>
  );
};

export const AddressBook = ({ record, ...props }) => {
  const form = useForm();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [allAddresses, setAllAddresses] = useState([]);
  const [addresses, setAddresses] = useState([]);

  const defaultSort = { field: "name", order: "ASC" };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = sessionStorage.getItem(`AddressBook`);
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? Number(sessionPerPage) : 10,
  );

  useEffect(() => {
    if (record?.id) {
      fetchSavedAddresses(record.id, notify, setLoading, setAllAddresses);
    }
  }, []);

  useEffect(() => {
    setAddresses(allAddresses);
    if (!record?.id) {
      form.change("savedAddresses.items", allAddresses);
    }
  }, [allAddresses]);

  // Use `useList` for pagination and sorting
  const listContext = useList({
    data: addresses,
    ids: addresses.map((item) => item.id),
    perPage: defaultPerPage,
    sort: defaultSort,
    loaded: true, // renders loading bars if false
    loading: loading,
    basePath: "/savedAddresss",
    resource: "savedAddresss",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      sessionStorage.setItem(`AddressBook`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
  }, [listContext?.perPage]);

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <ListContextProvider value={listContext}>
          <ListToolbar
            {...props}
            filters={getListFilters(allAddresses, setAddresses)}
            actions={
              <ListActions
                form={form}
                formData={formData}
                allAddresses={allAddresses}
                setAllAddresses={setAllAddresses}
                hasCreate={true}
                notify={notify}
                loading={loading}
              />
            }
          />
          <Datagrid>
            <TextField source="name" label="Business Name" />
            <TextField source="street" label="Street Address" />
            <TextField source="city" label="City" />
            <TextField source="state" label="State" />
            <TextField source="zipCode" label="Zip Code" />
            <TextField source="country" label="Country" />
            <TextField source="phone" label="Phone" />
            <ListActionButtons
              form={form}
              formData={formData}
              allAddresses={allAddresses}
              setAllAddresses={setAllAddresses}
              notify={notify}
            />
          </Datagrid>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <Pagination {...listContext} />
          </div>
        </ListContextProvider>
      )}
    </FormDataConsumer>
  );
};

const ListActionButtons = ({
  form,
  formData,
  record,
  allAddresses,
  setAllAddresses,
  notify,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleEdit = () => {
    form.change(`savedAddress`, record);
    setIsOpen(true);
  };

  const handleRemove = async () => {
    try {
      if (record.id) {
        const deleteInput = { id: record.id };
        await API.graphql(
          graphqlOperation(deleteSavedAddress, { input: deleteInput }),
        );
      }

      const updatedAddresses = allAddresses.filter(
        (addr) => addr.id !== record.id,
      );
      setAllAddresses(updatedAddresses);
    } catch (error) {
      logError("accounts:AddressBook:handleRemove", error, notify);
    }
  };

  // Save the edited address and update the form
  const handleSave = async () => {
    debugger;
    try {
      let updatedAddress = formData.savedAddress;
      if (updatedAddress?.id && updatedAddress?.accountId) {
        const updated = await updateSavedAddressRecord(updatedAddress);
        if (!updated) {
          logError(
            "accounts:AddressBook:handleSave",
            new Error("updateSavedAddress returned no data"),
            notify,
          );
          return;
        }
        updatedAddress = updated;
        notify("Address updated successfully.", "success");
      }

      const updatedAddresses = allAddresses.map((addr) =>
        addr.id === updatedAddress.id ? updatedAddress : addr,
      );
      setAllAddresses(updatedAddresses);

      form.change(`savedAddress`, undefined);
      setIsOpen(false);
    } catch (error) {
      logError("accounts:AddressBook:handleSave", error, notify);
    }
  };

  const handleClose = () => {
    form.change(`savedAddress`, undefined);
    setIsOpen(false);
  };

  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <Button label="Edit" color="primary" onClick={handleEdit}>
        <EditIcon />
      </Button>
      &nbsp;
      <Button label="Remove" color="default" onClick={handleRemove}>
        <RemoveIcon />
      </Button>
      {isOpen && (
        <AddressDialog
          open={isOpen}
          title="Edit Address"
          formData={formData}
          onSave={handleSave}
          onClose={handleClose}
        />
      )}
    </div>
  );
};
